export type QuickActionsConfig = {
    myDisplayName: string;
    myVCardUrl: string;
};

/**
 * Strict config accessor for SMS/vCard flows. No fallbacks in dev.
 * Reads from Vite env and allows local override via localStorage for convenience.
 * Throws if missing to surface misconfig immediately.
 */
export function getQuickActionsConfig(): QuickActionsConfig {
    // Allow local override in dev without rebuild
    let localName: string | null = null;
    let localCard: string | null = null;
    try {
        localName = localStorage.getItem('gv:myDisplayName');
        localCard = localStorage.getItem('gv:myVCardUrl');
    } catch { /* ignore */ }

    const envName = (import.meta as any)?.env?.VITE_MY_DISPLAY_NAME as string | undefined;
    const envCard = (import.meta as any)?.env?.VITE_MY_VCARD_URL as string | undefined;

    const myDisplayName = (localName || envName || '').trim();
    const myVCardUrl = (localCard || envCard || '').trim();

    if (!myDisplayName) {
        throw new Error('Quick actions config missing: VITE_MY_DISPLAY_NAME (or localStorage gv:myDisplayName)');
    }
    if (!myVCardUrl) {
        throw new Error('Quick actions config missing: VITE_MY_VCARD_URL (or localStorage gv:myVCardUrl)');
    }

    return { myDisplayName, myVCardUrl };
}
